import React from 'react';
import './Page.css';
import PicBar from './PicBar.js';
import Footer from './Footer/Footer.js'
import Navigation from './Navigation.js';
import { useState, useEffect } from 'react';
import BottomBar from './BottomBar/BottomBar';
import WelcomeWelcome from './ContentPages/WelcomeWelcome/WelcomeWelcome';
import { Route, Routes } from 'react-router-dom';
import WelcomeAbout from './ContentPages/WelcomeAbout/WelcomeAbout';
import Offering from './ContentPages/Offering/Offering.js';
import References from './ContentPages/References/References';
import Certificates from './ContentPages/Certificates/Certificates.js';
import Way from './ContentPages/Way/Way';
import DataPage from './BottomPages/DataPage.js';
import ImpPage from './BottomPages/ImpPage.js';
import UsePage from './BottomPages/UsePage';
import Beratung from '../src/ContentPages/Offering/Beratung.js';
import Therapie from '../src/ContentPages/Offering/Therapie.js';
import Ablauf from '../src/ContentPages/Offering/Ablauf.js';

import Online from '../src/ContentPages/Offering/Online.js';
import Kosten from '../src/ContentPages/Offering/Kosten.js';

import Dozenten from '../src/ContentPages/Offering/Dozenten.js';
import Gesundheitsfoerderung from '../src/ContentPages/Offering/Gesundheitsfoerderung.js';
import {useLocation} from 'react-router-dom';








import './PageContent.css';






let pagePositionsByPath = {
  "/": 1,
  "/UeberMich": 2,
  "/Ernaehrungsberatung": 3,
  "/Ernaehrungstherapie": 3,
  "/Kostenuebernahme": 3,
  "/Online":3,
  "/BetrieblicheGesundheitsfoerderung": 3,
  "/Dozententaetigkeit": 3,
  "/Referenzen": 4,
  "/AerztlicheBescheinigung": 5,
  "/Anfahrt": 6,
  "/Datenschutzerklaerung":8

  


}

const Page = () => {


  const location = useLocation();

  console.log(location.pathname);


  const navigationItems = ['Willkommen', 'Über Mich', 'Mein Angebot', 'Referenzen', 'Bescheinigungen', 'Anfahrt'];
  const [pageposition, setPagePosition] = useState(1);

  useEffect(() => {
    const handleBackNavigation = () => {

      console.log(window.location.pathname)
      console.log(pagePositionsByPath[window.location.pathname])
      setPagePosition(pagePositionsByPath[window.location.pathname])
    };

    window.addEventListener('popstate', handleBackNavigation);

    return () => {
      window.removeEventListener('popstate', handleBackNavigation);
    };

  }, []);



  




  return (
    <div className='PageWrapper'>



      <div className="BasicPage" id="page">

        <PicBar setPagePosition={setPagePosition} />
        <Navigation navigationItems={navigationItems} pageposition={pageposition} navnumber={1} setPagePosition={setPagePosition} />

        {(pageposition === 3 || location.pathname === '/Online' || location.pathname ==='/Ernaehrungsberatung'|| location.pathname ==='/Ernaehrungstherapie'  
        || location.pathname ==='/Kostenuebernahme'|| location.pathname ==='/Ablauf'|| location.pathname ==='/BetrieblicheGesundheitsfoerderung'|| location.pathname ==='/Dozententaetigkeit') && (
          <Offering />
        )}

        <Routes>
          <Route path="/" element={<div className='PageContent'> <WelcomeWelcome /> </div>} />
          <Route path="/UeberMich" element={<div className='PageContent'> <WelcomeAbout /> </div>} />
          <Route path="/Ernaehrungsberatung" element={<div className='PageContent'> <Beratung /> </div>} />
          <Route path="/Ernaehrungstherapie" element={<div className='PageContent'> <Therapie /> </div>} />
          <Route path="/Online" element={<div className='PageContent'> <Online /> </div>} />
          <Route path="/Kostenuebernahme" element={<div className='PageContent'> <Kosten /> </div>} />
          <Route path="/Ablauf" element={<div className='PageContent'> <Ablauf /> </div>} />
          <Route path="/BetrieblicheGesundheitsfoerderung" element={<div className='PageContent'> <Gesundheitsfoerderung /> </div>} />
          <Route path="/Dozententaetigkeit" element={<div className='PageContent'> <Dozenten /> </div>} />
          <Route path="/Referenzen" element={<div className='PageContent'> <References /> </div>} />
          <Route path="/AerztlicheBescheinigung" element={<div className='PageContent'> <Certificates /> </div>} />
          <Route path="/Anfahrt" element={<div className='PageContent'> <Way /> </div>} />
          <Route path="/Datenschutzerklaerung" element={<div className='PageContent'> <DataPage /> </div>} />
          <Route path="/Impressum" element={<div className='PageContent'> <ImpPage /> </div>} />
          <Route path="/Nutzungsbedingungen" element={<div className='PageContent'> <UsePage /> </div>} />
        </Routes>

        <Footer />
        <BottomBar setPagePosition={setPagePosition} />
      </div>
    </div>
  );
};

export default Page;